import { c as _c } from "react/compiler-runtime";
import { formatMoney } from "@/lib/currencies";
import { cn } from "@/lib/utils";
import { AddToCartButton } from "./AddToCartButton";
import { MainProductImage } from "./products/main-product-image";
export const ProductBottomStickyCard = t0 => {
  const $ = _c(46);
  const {
    product,
    variant,
    subscription,
    currency,
    locale,
    domain,
    theme,
    show,
    settings
  } = t0;
  if (!variant) {
    return null;
  }
  const t1 = show ? 0 : -1;
  const t2 = show ? "transform translate-y-0 shadow-[0_-4px_6px_-1px_rgb(0_0_0_/_0.1),_0_-2px_4px_-2px_rgb(0_0_0_/_0.1)]" : "transform translate-y-full";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("fixed bottom-0 max-w-[100vw] left-0 right-0 bg-white/90 backdrop-blur-xs border-t py-2 sm:py-4 transition-all duration-300 ease-out z-11", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = settings?.pageWidth === "narrow" && "max-w-6xl";
  const t5 = settings?.pageWidth === "default" && "max-w-7xl";
  const t6 = settings?.pageWidth === "wider" && "max-w-8xl";
  const t7 = settings?.pageWidth === "widest" && "max-w-9xl";
  let t8;
  if ($[2] !== t4 || $[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
    t8 = cn("mx-auto w-full max-w-7xl gap-x-2 px-4 sm:px-6 lg:px-8 flex justify-between items-center", t4, t5, t6, t7);
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== product.name || $[8] !== variant.images[0]) {
    t9 = variant.images[0] && <MainProductImage className="w-16 h-16 rounded-lg bg-neutral-100 object-cover object-center" src={variant.images[0]} loading="eager" priority={true} alt={product.name} />;
    $[7] = product.name;
    $[8] = variant.images[0];
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <div className="shrink-0">{t9}</div>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== product.name) {
    t11 = <h3 className="font-semibold text-xs sm:text-base md:text-lg whitespace-nowrap text-ellipsis overflow-clip">{product.name}</h3>;
    $[12] = product.name;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== currency || $[15] !== locale || $[16] !== variant.price) {
    t12 = formatMoney({
      amount: variant.price,
      currency,
      locale
    });
    $[14] = currency;
    $[15] = locale;
    $[16] = variant.price;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12) {
    t13 = <p className="text-xs sm:text-sm">{t12}</p>;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t11 || $[21] !== t13) {
    t14 = <div className="flex-1 min-w-0">{t11}{t13}</div>;
    $[20] = t11;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t10 || $[24] !== t14) {
    t15 = <div className="flex items-center gap-x-2 sm:gap-x-4 min-w-0">{t10}{t14}</div>;
    $[23] = t10;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = theme.buttonTextColor ?? undefined;
  const t17 = theme.buttonBackgroundColor ?? undefined;
  const t18 = theme.buttonHoverBackgroundColor ?? undefined;
  const t19 = theme.priceColor ?? undefined;
  let t20;
  if ($[26] !== t16 || $[27] !== t17 || $[28] !== t18 || $[29] !== t19) {
    t20 = {
      "--theme-product-details-add-to-cart-button-color": t16,
      "--theme-product-details-add-to-cart-button-background-color": t17,
      "--theme-product-details-add-to-cart-button-hover-background-color": t18,
      "--theme-product-details-price-color": t19
    };
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = cn("text-[var(--theme-product-details-add-to-cart-button-color,#fff)]", "bg-[var(--theme-product-details-add-to-cart-button-background-color,#000)]", "hover:bg-[var(--theme-product-details-add-to-cart-button-hover-background-color,#222)]");
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== domain || $[33] !== product || $[34] !== subscription || $[35] !== t20 || $[36] !== variant) {
    t22 = <AddToCartButton id="" variant={variant} subscription={subscription} product={product} domain={domain} style={t20} className={t21} />;
    $[32] = domain;
    $[33] = product;
    $[34] = subscription;
    $[35] = t20;
    $[36] = variant;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t15 || $[39] !== t22 || $[40] !== t8) {
    t23 = <div className={t8}>{t15}{t22}</div>;
    $[38] = t15;
    $[39] = t22;
    $[40] = t8;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t1 || $[43] !== t23 || $[44] !== t3) {
    t24 = <div tabIndex={t1} className={t3}>{t23}</div>;
    $[42] = t1;
    $[43] = t23;
    $[44] = t3;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  return t24;
};